/*
 * File: cell-action.ts
 * Created: 2025-12-06 10:04:55
 * Author: Val Liu <valuis0429@gmail.com>
 * -----
 * Last Modified: 2026-02-04 16:27:38
 * Modified By: Val Liu <valuis0429@gmail.com>
 */

import BaseTableBodyCell from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import CellActionBase from "@root/components/table/elements/body/cell-action/base/cell-action-base";
import { IQuickUnit } from "@root/core/utilities/quick-helper";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class CellAction extends BaseTableBodyCell {
    @Prop({ type: Object, required: true })
    quick!: IQuickUnit;

    @Prop({ type: Array, default: () => [] })
    declare value: CellActionBase[];

    static defaultVariant: string = "secondary";
    get defaultVariant() {
        return CellAction.defaultVariant;
    }
}
